import React from 'react';
import { ReactComponent as ArrowCircleIcon } from '../../assets/svg/icon-arrow-circle-right.svg';
import { PageSwitcherSC } from './page-switcher.styled';

interface PageSwitcherProps {
  switcherCurrentPage: number;
  pages: any[];
  onSwitcherPageChange: (p: number) => void;
}

const PageSwitcher: React.FC<PageSwitcherProps> = ({
  pages,
  switcherCurrentPage,
  onSwitcherPageChange,
}) => {
  const onPageChange = (buttonType: string | number) => {
    if (typeof buttonType === 'number') {
      return onSwitcherPageChange(buttonType);
    } else {
      if (buttonType === 'next' && switcherCurrentPage < pages.length - 1) {
        return onSwitcherPageChange(switcherCurrentPage + 1);
      }
      if (buttonType === 'back' && switcherCurrentPage > 0) {
        return onSwitcherPageChange(switcherCurrentPage - 1);
      }
    }
  };

  return (
    <PageSwitcherSC>
      <div className="controls">
        <div
          className={switcherCurrentPage === 0 ? 'back disabled' : 'back'}
          onClick={() => onPageChange('back')}
        >
          <ArrowCircleIcon />
        </div>
        <div className="count">
          {pages.map((page, index) => {
            return (
              <div
                key={page.type}
                className={index === switcherCurrentPage ? 'dot active' : 'dot'}
                onClick={() => onPageChange(index)}
              ></div>
            );
          })}
        </div>
        <div
          className={switcherCurrentPage === pages.length - 1 ? 'next disabled' : 'next'}
          onClick={() => onPageChange('next')}
        >
          <ArrowCircleIcon />
        </div>
      </div>
    </PageSwitcherSC>
  );
};

export default PageSwitcher;
